export const convertToVisitTaskRequest = (data) => ({
  taskId: data.task.id,
  hours: data.hours,
  rate: data.rate,
  comment: data.comment,
  isCritical: data.isCritical,
});

export const convertToVisitPartRequest = (data) => ({
  partId: data.part.id,
  partPrice: data.partPrice,
  count: data.count,
  comment: data.comment,
  isCritical: data.isCritical,
});

export const imageRequest = (files) => {
  const imageFile = new FormData();
  imageFile.append('file', files[0]);
  return imageFile;
};

export const convertToVehicleRequest = (data) => {
  const { vin, number, model, year, mileage, engine, color, fuel, transmission, wheelDrive, rate, client } = data;
  return {
    vin,
    modelId: model?.id,
    rateId: rate?.id,
    clientId: client?.id,
    number: number || undefined,
    year: year || undefined,
    mileage: mileage || undefined,
    engine: engine || undefined,
    color: color?.name || undefined,
    fuelType: fuel?.name || undefined,
    transmissionType: transmission?.name || undefined,
    wheelDriveType: wheelDrive?.name || undefined,
  };
};
